/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/
/* eslint @typescript-eslint/no-explicit-any: 0 */

import ReturnData from "./returndata";
import Response from "./response";
import { AxiosError } from "axios";

export default class RestAPIError extends Error {
	private _data: any = null;

	constructor(
		private readonly sourceData: ReturnData | Response<any> | AxiosError,
		...parameters: any[]
	) {
		super(...parameters);

		this.name = "RestAPIError";

		if (this.isAxiosError === false) {
			this.message = sourceData.message || "Unknown Error";
			this.setData(parameters);
		} else {
			this.message = sourceData.message;
		}
	}

	public get isAxiosError() {
		// @ts-ignore
		return this.sourceData instanceof AxiosError;
	}
	public get domain() {
		if (this.isAxiosError) {
			const {
				// @ts-ignore
				response: {
					config: { baseURL, url }
				}
			} = this.sourceData;
			return `${baseURL}${url}`;
		} else {
			// @ts-ignore
			return this.sourceData.domain;
		}
	}
	public get status() {
		if (this.isAxiosError) {
			const {
				// @ts-ignore
				response: { status }
			} = this.sourceData;
			return status;
		} else {
			return this.sourceData.code;
		}
	}
	public get code() {
		if (this.isAxiosError) {
			if (this.sourceData.code !== "ERR_NETWORK") {
				return this.data?.errorCode as string;
			}
		}
		return this.sourceData.code;
	}
	public get data() {
		if (this.isAxiosError) {
			try {
				if ("response" in this.sourceData) {
					const {
						// @ts-ignore
						response: { data }
					} = this.sourceData;
					return data;
				}
			} catch (error: any) {
				console.error("#RestAPIError# get data failed", error);
			}
		}
		// @ts-ignore
		return this.sourceData.data;
	}
	public get parameter() {
		return this._data?.lenght > 0 ? this._data[0] : "";
	}

	public setData(parameters: any[]) {
		if (parameters.length > 0) {
			this._data = new Array(parameters.length);
			for (let index = 0; index < parameters.length; index++) {
				this._data[index] = parameters[index];
				if (
					typeof this._data[index] === "string" &&
					(this._data[index].slice(0, 1).match(/{/) || this._data[index].match(/true|false/))
				) {
					try {
						this._data[index] = JSON.parse(this._data[index]);
					} catch (error: any) {
						console.warn("#RestAPIError# Error", error);
					}
				}
			}
		} else {
			this._data = null;
		}
	}
}
